import {NgModule} from '@angular/core';
import {SharedModule} from '@ispm/shared/shared.module';
import { PacsLauncherComponent } from '@ispm-client/modules/pacs-launcher/component/pacs-launcher.component';
import { PacsLauncherService } from '@ispm-client/modules/pacs-launcher/services/pacs-launcher.service';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        PacsLauncherComponent
    ],
    providers: [PacsLauncherService],
    exports: [PacsLauncherComponent],    
    entryComponents: [
    ]
})
export class PACSLauncherModule {
}
